import styled from 'styled-components';
import Button from '../../../../../Button';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-content: center;
  text-align: center;
  position: relative;
  margin-top: 96px;
  padding: 0 24px;

  @media screen and (max-width: 992px) {
    position: static;
    padding: 0;
    /* align-items: stretch; */
  }
`;
const Description = styled.div`
  width: 335px;
  position: relative;
  top: -13px;
  left: 2px;
`;
const LinkButton = styled(Button)`
  display: block;
  width: 315px;
  height: 60px;
  margin-top: 11px;
  margin-left: 4px;
`;

export { Wrapper, Description, LinkButton };
